<template>
  <div>
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="recruit-desc design_box">
        <!--let list = {position:'',salary:'',city:'',claim:'',edu:''}-->
        <div class="recruit-desc-list" v-for="(item,index) in property.list" :key="index">
          <p class="recruit-desc-list-top"><span class="recruit-desc-list-top-name">{{item.position?item.position:'职位'}}</span><span
                  class="recruit-desc-list-top-price">{{item.salary?item.salary:'薪资金额'}}</span></p>
          <p class="recruit-desc-list-company">{{item.city?item.city:'城市'}} | {{item.claim?item.claim:'经验'}} | {{item.edu?item.edu:'学历'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    },
    created() {

    }
  };
</script>



